import React from "react"
import { LOGO_CBQ, wordmarkSources } from "../lib/campaignMedia.js"

/** <picture> con WebP si el navegador lo soporta; PNG de respaldo. */
function CampaignMediaImg({
  webp,
  webpSrcSet,
  sizes,
  png,
  alt = "",
  width,
  height,
  className,
  style,
  loading,
  decoding = "async",
}) {
  return (
    <picture>
      {webpSrcSet ? (
        <source type="image/webp" srcSet={webpSrcSet} sizes={sizes} />
      ) : webp ? (
        <source type="image/webp" srcSet={webp} />
      ) : null}
      <img
        src={png}
        alt={alt}
        width={width}
        height={height}
        className={className}
        style={style}
        loading={loading}
        decoding={decoding}
      />
    </picture>
  )
}

function LogoCbqImg({ alt = "Bomberos Quilpué", style, className, loading }) {
  return (
    <CampaignMediaImg
      webp={LOGO_CBQ.webp}
      png={LOGO_CBQ.png}
      alt={alt}
      width={LOGO_CBQ.width}
      height={LOGO_CBQ.height}
      style={style}
      className={className}
      loading={loading}
    />
  )
}

function WordmarkImg({ theme = "night", alt = "Con tu aporte llegaremos más alto", style, className }) {
  const src = wordmarkSources(theme)
  return (
    <CampaignMediaImg
      webpSrcSet={src.webpSrcSet}
      sizes={src.sizes}
      png={src.png}
      alt={alt}
      width={src.width}
      height={src.height}
      style={style}
      className={className}
      // LCP en hero: no lazy
      loading={undefined}
      decoding="async"
    />
  )
}

export { CampaignMediaImg, LogoCbqImg, WordmarkImg }
